export const EDUCATIONAL_AREAS = [
  { value: 'science', label: 'Science' },
  { value: 'mathematics', label: 'Mathematics' },
  { value: 'language', label: 'Language' },
  { value: 'government', label: 'Government' },
  { value: 'history', label: 'History' },
  { value: 'health', label: 'Health' },
  { value: 'reading', label: 'Reading' },
  { value: 'writing', label: 'Writing' },
  { value: 'spelling', label: 'Spelling' },
  { value: 'constitutional_history', label: 'Constitutional History' },
  { value: 'art', label: 'Art' },
  { value: 'music', label: 'Music' },
] as const

export type EducationalAreaValue = typeof EDUCATIONAL_AREAS[number]['value']

export function educationalAreaLabel(value: string): string {
  return EDUCATIONAL_AREAS.find((a) => a.value === value)?.label ?? value
}

export const AREA_COLORS: Record<EducationalAreaValue, string> = {
  science: 'bg-blue-100 text-blue-800',
  mathematics: 'bg-purple-100 text-purple-800',
  language: 'bg-green-100 text-green-800',
  government: 'bg-orange-100 text-orange-800',
  history: 'bg-amber-100 text-amber-800',
  health: 'bg-red-100 text-red-800',
  reading: 'bg-teal-100 text-teal-800',
  writing: 'bg-indigo-100 text-indigo-800',
  spelling: 'bg-cyan-100 text-cyan-800',
  constitutional_history: 'bg-yellow-100 text-yellow-800',
  art: 'bg-pink-100 text-pink-800',
  music: 'bg-violet-100 text-violet-800',
}

export function areaColor(value: string): string {
  return AREA_COLORS[value as EducationalAreaValue] ?? 'bg-gray-100 text-gray-800'
}
